var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
export default React.forwardRef(function (props, ref) {
    var onRemove = function () {
        props.onRemove && props.onRemove(props.value);
    };
    return (_jsxs(StyledRoot, __assign({ color: props.color }, { children: [_jsx(StyledValue, { children: props.value }), props.onRemove && (_jsx(StyledAction, __assign({ onClick: onRemove }, { children: _jsx(Icon.IonIcons5.IoCloseSharp, { size: 15 }) })))] })));
});
var StyledRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  background: ", ";\n  font-size: 12px;\n  color: ", ";\n  border-radius: 12px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  background: ", ";\n  font-size: 12px;\n  color: ", ";\n  border-radius: 12px;\n"])), function (props) { return props.color || "var(--brand-primary)"; }, function (props) { return (props.color ? "black" : "white"); });
var StyledValue = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n  padding: 4px 10px 4px 10px;\n"], ["\n  text-align: left;\n  padding: 4px 10px 4px 10px;\n"])));
var StyledAction = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: white;\n  text-align: left;\n  width: 15px;\n  height: 15px;\n  margin-left: -6px;\n  padding-right: 6px;\n  cursor: pointer;\n"], ["\n  color: white;\n  text-align: left;\n  width: 15px;\n  height: 15px;\n  margin-left: -6px;\n  padding-right: 6px;\n  cursor: pointer;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map